import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {WalletRoutingModule} from './wallet-routing.module';
import {SettingsComponent} from './components/settings/settings.component';
import {HyperwalletService} from './services/hyperwallet.service';
import {WalletService} from './services/wallet.service';

const MODULES = [SharedModule, WalletRoutingModule];
const COMPONENTS = [SettingsComponent];
const SERVICES = [
    HyperwalletService,
    WalletService,
];

@NgModule({
    imports: [...MODULES, CarouselModule],
    providers: [...SERVICES],
    declarations: [...COMPONENTS]
})
export class WalletModule {
}
